import {
  LegacyModuleNavigationItem,
  LegacyModuleNavigationItemConfig,
  LegacyUIModule,
  LegacyUIModuleVersion,
} from '~/legacy-components/LegacyNavigation/data';
import { getENVs } from '~/utils/helper';

const includeEmpIdInPath = (module: LegacyUIModule): boolean => {
  return ![LegacyUIModule.Workspace, LegacyUIModule.Home].includes(module);
};

const getLegacyUIPath = (
  navItem: LegacyModuleNavigationItemConfig,
  empId?: number,
): string => {
  const path = navItem.legacyUI ? navItem.legacyUI.path : '';
  if (empId && navItem.legacyUI && includeEmpIdInPath(navItem.module)) {
    return `${path}?emp=${empId}`;
  }

  return path;
};

const getLegacyNavigationPath = (
  navItem: LegacyModuleNavigationItemConfig,
  empId?: number,
): string => {
  switch (navItem.version) {
    case LegacyUIModuleVersion.LegacyV2:
      return navItem?.legacyV2?.path ?? '';
    case LegacyUIModuleVersion.LegacyUI:
      return getLegacyUIPath(navItem, empId);
    default:
      return '';
  }
};

const getLegacyNavigationHref = (
  navItem: LegacyModuleNavigationItemConfig,
  empId?: number,
): string => {
  const path = getLegacyNavigationPath(navItem, empId);
  return navItem.version === LegacyUIModuleVersion.LegacyV2
    ? `/v2${path}`
    : path;
};

export const getLegacyNavigationItem = (
  navItem: LegacyModuleNavigationItemConfig,
  empId?: number,
): LegacyModuleNavigationItem => {
  return {
    ...navItem,
    path: getLegacyNavigationPath(navItem, empId),
    href: getLegacyNavigationHref(navItem, empId),
  };
};

export const resolveUndefinedModuleVersion = (
  navItem: LegacyModuleNavigationItemConfig,
): LegacyModuleNavigationItemConfig => {
  if (!!navItem.version) {
    return navItem;
  }

  const version = Object.values(LegacyUIModuleVersion).filter(
    (v: LegacyUIModuleVersion) => !!navItem[v],
  );

  const enableNewRoutes = getENVs('REACT_APP_ENABLE_NEW_ROUTES');

  return {
    ...navItem,
    version:
      enableNewRoutes && enableNewRoutes !== 'yes'
        ? version[0]
        : LegacyUIModuleVersion.LegacyUI,
  };
};
